import { responsiveFont } from './responsiveFont';
/**
 * Get responsive CSS for the `text` font style.
 * @beta Should not be used in production, as this might change.
 */
export function responsiveTextFont(props) {
    return responsiveFont('text', props);
}
//# sourceMappingURL=textFontStyle.js.map